import { useEffect } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const thCls = "px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-300";
const tdCls = "px-3 py-2 text-xs border-b border-gray-100 dark:border-gray-700 align-middle";

export function OrderDispatchReceived({ detailsFromOrderDispatchReceived, isOpen, onClose }) {
    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [isOpen]);

    if (!isOpen) return null;

    const totalQty      = detailsFromOrderDispatchReceived.reduce((s, i) => s + i.quantity, 0);
    const totalSubtotal = detailsFromOrderDispatchReceived.reduce((s, i) => s + i.subtotal, 0);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" aria-modal="true" role="dialog">
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
            <div className="relative z-10 w-full max-w-4xl max-h-[90vh] flex flex-col rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-2xl overflow-hidden">

                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 bg-blue-600 dark:bg-blue-700 flex-shrink-0">
                    <h5 className="text-base font-semibold text-white flex items-center gap-2">
                        <i className="fas fa-receipt"></i>
                        Detalles del pedido
                    </h5>
                    <button type="button" onClick={onClose} className="text-white/80 hover:text-white transition-colors p-1 rounded" aria-label="Cerrar">
                        <i className="fas fa-times text-lg"></i>
                    </button>
                </div>

                {/* Body */}
                <div className="flex-1 overflow-y-auto px-6 py-5 bg-white dark:bg-gray-800">
                    <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-700">
                        <table className="min-w-full text-sm border-separate border-spacing-0" id="table-to-xls">
                            <thead>
                                <tr>
                                    <th className={thCls}>SKU</th>
                                    <th className={`${thCls} text-left`}>Producto</th>
                                    <th className={thCls}>Und.</th>
                                    <th className={`${thCls} bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300`}>Cant.</th>
                                    <th className={`${thCls} bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300`}>Precio</th>
                                    <th className={`${thCls} bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300`}>Subtotal</th>
                                </tr>
                            </thead>
                            <tbody>
                                {detailsFromOrderDispatchReceived.map((item, i) => (
                                    <tr key={i} className="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                                        <td className={`${tdCls} text-center font-mono text-gray-600 dark:text-gray-400`}>{item.productSku}</td>
                                        <td className={`${tdCls} font-medium text-gray-800 dark:text-gray-200`}>{item.productName}</td>
                                        <td className={`${tdCls} text-center text-gray-600 dark:text-gray-400`}>{item.unitName}</td>
                                        <td className={`${tdCls} text-center font-bold text-blue-700 dark:text-blue-300 bg-blue-50 dark:bg-blue-900/10`}>{item.quantity}</td>
                                        <td className={`${tdCls} text-right text-emerald-700 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/10`}>S/ {Number(item.price).toFixed(6)}</td>
                                        <td className={`${tdCls} text-right font-semibold text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/10`}>S/ {Number(item.subtotal).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr className="bg-gray-800 dark:bg-gray-950">
                                    <td colSpan={3} className="px-3 py-2 text-xs font-bold text-right text-white uppercase border-t border-gray-600">Total</td>
                                    <td className="px-3 py-2 text-xs text-center font-bold text-blue-300 border-t border-gray-600">{Number(totalQty).toFixed(0)}</td>
                                    <td className="px-3 py-2 border-t border-gray-600 bg-gray-800"></td>
                                    <td className="px-3 py-2 text-xs text-right font-bold text-amber-300 border-t border-gray-600">S/ {Number(totalSubtotal).toFixed(2)}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 flex-shrink-0">
                    <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="inline-flex items-center gap-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-medium px-3 py-1.5 transition-colors"
                        table="table-to-xls"
                        filename="ReporteVentas"
                        sheet="report"
                        buttonText="↓ Exportar XLS"
                    />
                    <button type="button" onClick={onClose} className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm font-medium px-4 py-2 transition-colors">
                        <i className="fas fa-times"></i>Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}
